"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.marginNotificationsMiddleware = void 0;
var _snackbarActions = require("../../actions/snackbarActions");
var marginNotificationsMiddleware = exports.marginNotificationsMiddleware = function marginNotificationsMiddleware(store) {
  return function (next) {
    return function (action) {
      var result = next(action);
      if (action.type === _snackbarActions.ADD_SNACK) {
        var notifications = store.getState().margin.notifications;
        localStorage.setItem('marginNotifications', JSON.stringify(notifications));
      }
      return result;
    };
  };
};